export default ({driver: {address_city = ''} = {}} = {}) => address_city;
